export default "__VITE_ASSET__Dx$M91HA__"